import {
  GlobalCard,
  GlobalCardBody,
  GlobalCardHeader,
  GlobalCardHeaderTitle,
} from '@global-engineering-shared/gweb-material-lab';
import React, { useEffect, useState } from 'react';

import TimeRangeSelectButton from 'components/TimeRangeSelectButton';
import VisibilityToggleButton from 'components/VisibilityToggleButton';
import { Dates } from 'context/DateProvider/DateProvider';
import EventsChart from 'features/Events/components/EventsChart';
import { EventData } from 'features/Events/types/eventData';
import FrameDetailsEventsChartLabel from 'features/FrameDetails/Containers/FrameDetailsEventsChartContainer/components/FrameDetailsEventsChartLabel';
import useStyles from 'features/FrameDetails/Containers/FrameDetailsEventsChartContainer/FrameDetailsEventsChartContainer.styles';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { PALETTE_BLUE_50 } from 'utils/colours';
import { FRAMES_API_URL } from 'utils/environmentVariables';

type FrameDetailsEventsChartContainerProps = {
  frameId: string;
  dateTimeRange: Dates;
  setDateTimeRange: React.Dispatch<React.SetStateAction<Dates>>;
};

const FrameDetailsEventsChartContainer = ({
  frameId,
  dateTimeRange,
  setDateTimeRange,
}: FrameDetailsEventsChartContainerProps) => {
  const classes = useStyles();
  const [events, setEvents] = useState<EventData[]>([]);
  const [showEvents, setShowEvents] = useState(true);
  const { fetchDataWithToken } = useFetchWithToken();

  useEffect(() => {
    if (frameId) {
      const url = `${FRAMES_API_URL}/${frameId}/events?from=${dateTimeRange.from}&to=${dateTimeRange.to}`;
      fetchDataWithToken<EventData[]>(url, (data) => setEvents(data));
      setShowEvents(true);
    }
  }, [frameId, dateTimeRange]);

  const getTitleComponent = () => () =>
    (
      <div className={classes.title}>
        <div className={classes.titleContainer}>
          <FrameDetailsEventsChartLabel dateTimeRange={dateTimeRange} />
          <TimeRangeSelectButton period={1} unit="hours" setDateTimeRange={setDateTimeRange} />
          <TimeRangeSelectButton period={2} unit="hours" setDateTimeRange={setDateTimeRange} />
        </div>
        <VisibilityToggleButton
          text="Hide Events"
          visibilityValue={false}
          setWithVisibilityValue={setShowEvents}
        />
      </div>
    );

  return (
    <>
      {showEvents ? (
        <GlobalCard className={classes.root}>
          <GlobalCardHeader className={classes.header}>
            <GlobalCardHeaderTitle TitleComponent={getTitleComponent()} />
          </GlobalCardHeader>
          <GlobalCardBody className={classes.body}>
            <EventsChart
              chartId={`events-chart-${frameId}`}
              chartData={events}
              minDateTimeRange={dateTimeRange.from}
              maxDateTimeRange={dateTimeRange.to}
              lineColor={PALETTE_BLUE_50}
            />
          </GlobalCardBody>
        </GlobalCard>
      ) : (
        <div className={classes.showEventsContainer}>
          <VisibilityToggleButton
            text="Show Events"
            visibilityValue={true}
            setWithVisibilityValue={setShowEvents}
          />
        </div>
      )}
    </>
  );
};

export default FrameDetailsEventsChartContainer;
